import { BaseService } from 'shared/services/BaseService';
import { ILISTranscode } from '../types';

class LISTranscodesService extends BaseService<ILISTranscode> {
  constructor() {
    super('req-lab-transcodes');
  }
}

export const lisTranscodesService = new LISTranscodesService();
